import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=27a15e42&scoped=true&"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts&"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=27a15e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a15e42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItem,VSelect})
